import React from 'react';
import '../stylings/Popup.css';

export default function Popup({ open, data, onClose }) {
  if (!open || !data || data.length === 0) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-container" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close-btn" onClick={onClose} aria-label="Close popup">
          <i className="fas fa-times"></i>
        </button>
        {data.map((item, idx) => (
          <div key={idx} className="popup-item">
            {item.image && (
              <img src={item.image} alt={item.title || 'Announcement'} className="popup-img" />
            )}
            {item.title && <h4 className="popup-title">{item.title}</h4>}
            {item.description && <p className="popup-desc">{item.description}</p>}
            {item.link && (
              <a href={item.link} target="_blank" rel="noreferrer" className="popup-cta-btn">
                Know More
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
